import { ComponentPropsWithoutRef } from 'react'

import logo from '@/assets/logo.svg'
import logoColor from '@/assets/logo-color.svg'
import { useIsDark } from '@/hooks'

function Logo(props: LogoProps) {
  const { colored, ...rest } = props
  const prefersDarkMode = useIsDark()
  const isColored = colored !== undefined ? colored : !prefersDarkMode
  return <img src={isColored ? logoColor : logo} alt="Logo" {...rest} />
}

export interface LogoProps extends ComponentPropsWithoutRef<'img'> {
  colored?: boolean
}

export default Logo
